<div class="group-rule">
  <p class="rule-description">
    Create advanced targeting rules by combining multiple conditions with logical operators.
  </p>

  <div class="operator-selection">
    <h4>Logical Operator</h4>
    <div class="operator-buttons">
      <button
        mat-flat-button
        color="primary"
        class="operator-btn"
        type="button"
        [class.selected]="operator === 'AND'"
        (click)="setOperator('AND')"
      >
        AND
        <small>All conditions must be true</small>
      </button>
      <button
        mat-flat-button
        color="primary"
        class="operator-btn"
        type="button"
        [class.selected]="operator === 'OR'"
        (click)="setOperator('OR')"
      >
        OR
        <small>Any condition must be true</small>
      </button>
    </div>
  </div>

  <div class="child-rules-container">
    <div class="child-rules-header">
      <h4>Rule Conditions</h4>
      <div class="rule-actions">
        <div class="dropdown">
          <button mat-flat-button color="primary" type="button" class="add-rule-btn">Add Condition ▾</button>
          <div class="dropdown-content">
            <a
              href="#"
              *ngFor="let ruleType of ruleTypes"
              (click)="$event.preventDefault(); addChildRule(ruleType.value)"
            >
              {{ ruleType.label }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="empty-state" *ngIf="childRulesArray.length === 0">
      <p>No conditions added. Add at least one condition to enable the feature.</p>
    </div>

    <div class="child-rule" *ngFor="let childRule of childRulesArray.controls; let i = index">
      <div class="child-rule-header">
        <div class="rule-type">{{ getRuleTypeLabel(childRule.value.type) }}</div>
        <button mat-button color="primary" type="button" class="remove-rule-btn" (click)="removeChildRule(i)">
          Remove
        </button>
      </div>

      <div class="child-rule-content">
        <!-- Boolean Rule -->
        <cbre-boolean-rule
          *ngIf="childRule.value.type === 'boolean'"
          [parentForm]="getChildFormGroup(i)"
          (ruleChanged)="onChildRuleChanged(i, $event)"
        >
        </cbre-boolean-rule>

        <!-- Email Rule -->
        <cbre-email-rule
          *ngIf="childRule.value.type === 'email'"
          [parentForm]="getChildFormGroup(i)"
          (ruleChanged)="onChildRuleChanged(i, $event)"
        >
        </cbre-email-rule>

        <!-- User Group Rule -->
        <cbre-user-group-rule
          *ngIf="childRule.value.type === 'userGroup'"
          [parentForm]="getChildFormGroup(i)"
          (ruleChanged)="onChildRuleChanged(i, $event)"
        >
        </cbre-user-group-rule>

        <!-- User Group Rule -->
        <cbre-user-role-rule
          *ngIf="childRule.value.type === 'userRole'"
          [parentForm]="getChildFormGroup(i)"
          (ruleChanged)="onChildRuleChanged(i, $event)"
        >
        </cbre-user-role-rule>

        <!-- Region Rule -->
        <cbre-region-rule
          *ngIf="childRule.value.type === 'region'"
          [parentForm]="getChildFormGroup(i)"
          (ruleChanged)="onChildRuleChanged(i, $event)"
        >
        </cbre-region-rule>

        <!-- Line of Business Rule -->
        <cbre-line-of-business-rule
          *ngIf="childRule.value.type === 'lineOfBusiness'"
          [parentForm]="getChildFormGroup(i)"
          (ruleChanged)="onChildRuleChanged(i, $event)"
        >
        </cbre-line-of-business-rule>

        <!-- Line of Business Rule -->
        <cbre-group-rule
          *ngIf="childRule.value.type === 'group'"
          [parentForm]="getChildFormGroup(i)"
          (ruleChanged)="onChildRuleChanged(i, $event)"
        >
        </cbre-group-rule>
      </div>
    </div>
  </div>
</div>
